import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
//import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { CollapseNavbarComponent } from './collapse-navbar.component';
import { RouterModule } from '@angular/router';

@NgModule({
//  imports: [BrowserModule, NgbModule, RouterModule.forRoot([])],
  imports: [BrowserModule, RouterModule.forRoot([])],
  declarations: [CollapseNavbarComponent],
  exports: [CollapseNavbarComponent],
  bootstrap: [CollapseNavbarComponent]
})
export class AppCollapseNavbarModule {
}
